import Skeleton from "@mui/material/Skeleton"


export const LoadingStats = () =>
{
  return(
    <div>
      {[1, 2, 3, 4].map((i, k) => <Skeleton key={k} height={40} />)}
     </div>)
}